import React, { useEffect } from 'react';
import * as CONSTANTS from '../../utils/CONSTANTS';
import { makeSideBarActive } from '../../utils/EllowUtils';
import SideMenu from "../sideMenu";
import DashboardHeader from "../topbar";
import { useState } from 'react';
import Styles from "./styles.module.scss";
import { TabStrip } from "@progress/kendo-react-layout";
import Tab from "../../components/tab";
import { TabStripSelectEventArguments } from "@progress/kendo-react-layout";
import  CompanyTab  from './companyTab';
import DraftCompanies from './draftCompanie';
import { getAllCompanies , getPendingCompanies , getDraftCompanies , approveOrRejectCustomer , updateSourcedBy, userLevelApproveRejectCustomer , getAllocatedto, customerAllocation, blackListProvider } from './services';
import mixpanelData, { viewedpageMixpanel } from '../../utils/mixpanel';
import AllCompaniesTab from './allcompaniesTab';
import { getAPI } from '../../api/api';
import NotificationAlert from '../../components/notification';

function Company() {
  
  const menu = makeSideBarActive(CONSTANTS.sideMenu, 3)
  const BreadcrumsValues = ["Companies"]

  const [sort, setSort] = useState<any>([]);
  const [searchValue, setsearchValue] = useState<any>(null)
  const [filterValues, setFilterValues] = useState<any>(null)
  const [filter, setFilter] = useState<any>(null)
  const [selected, setSelected] = useState<number>(0)
  const [allTotal, setAllTotal] = useState<number>(0)
  const [draftTotal, setDraftTotal] = useState<number>(0)
  const [hirerCompanyData, setHirerCompanyData] = useState<any>()
  const [providerCompanyData, setProviderCompanyData] = useState<any>()
  const [draftCompanyData, setDraftCompanyData] = useState<any>()
  const [hirerTotal, setHirerTotal] = useState<any>()
  const [providerTotal, setProviderTotal] = useState<any>()
  const [approvedHirerComapnies, setApprovedHirerComapnies] =  useState<any>()
  const [approvedProviderComapnies, setApprovedProviderComapnies] =  useState<any>()
  const [rejectedHirerComapnies, setRejectedHirerComapnies] =  useState<any>()
  const [rejectedProviderComapnies, setRejectedProviderComapnies] =  useState<any>()
  const [approvedHirerComapniesTotal, setApprovedHirerComapniesTotal] =  useState<any>()
  const [approvedProviderComapniesTotal, setApprovedProviderComapniesTotal] =  useState<any>()
  const [rejectedHirerComapniesTotal, setRejectedHirerComapniesTotal] =  useState<any>()
  const [rejectedProviderComapniesTotal, setRejectedProviderComapniesTotal] =  useState<any>()
  const [allocatedTo, setAllocatedTo] = useState<any>()
  const [skillList, setSkillList] = useState<any>()
  const [notification, setNotification] = useState<boolean>(false)
  const [message, setMessage] = useState<string>('')
  const [type, setType] = useState<string>('')
  const [icon, setIcon] = useState<boolean>()
  const [blacklistedProviderCompanies, setBlacklistedProviderCompanies] = useState<any>()
  const [blackListedCompaniesTotal, setBlacklistedCompaniesTotal] = useState<any>()

  useEffect(() => {
    
    getDraftCompaniesData(1, 25, '',{ "companyStatus": 1}, '')
    getPendingCompaniesData(1, 25, "",{ "companyType": 1}, 1)
    getPendingCompaniesData(1, 25, "", { "companyType": 1}, 2 )
    getAllCompaniesData(1, 25, "" , { "companyType": 1,"companyStatus": 4},"", "approvedHirerCompanies")
    getAllCompaniesData(1, 25, "", { "companyType": 2, "companyStatus": 4 }, "", "approvedProviderCompanies")
    getAllCompaniesData(1, 25, "" , { "companyType": 2,"companyStatus": 9},"", "blacklistedProviderCompanies")
    getAllCompaniesData(1, 25, "" , { "companyType": 1,"companyStatus": 5},"", "rejectedHirerCompanies")
    getAllCompaniesData(1, 25, "" , { "companyType": 2,"companyStatus": 5},"", "rejectedProviderCompanies")
    getAllocation()
    viewedpageMixpanel()

    getAPI('https://api.ellow.io/common/api/v1/tg/skills').then((resp: any) => {
      if (resp && resp.status === 1) {
        setSkillList(resp.data);
      }
    })
    
  }, [])

  const getAllocation = () => {
    getAllocatedto().then((response: any) => {
      if (response && response.status === 1) {
        setAllocatedTo(response.data)
      }
    })
  }
  
  const getAllCompaniesData = (
    pageNumber: number,
    pageSize: number,
    searchValue: string,
    filters?: any,
    sort?: any,
    type?: string
  ) => {

    let filterBody = {
      filters : {
        companyType: filters.companyType !== undefined ? filters.companyType : undefined ,
        range: filters.dateWithin ? { start : filters.dateWithin.fromDate , end : filters.dateWithin.toDate } : undefined,
        allocatedTo: filters.allocatedTo,
        companyStatus: filters.companyStatus !== undefined ? filters.companyStatus : undefined ,
        googleLocations: filters.googleLocations,
        skills: filters.skills,
        sourcedBy: filters.sourcedBy
      }
    }
    
    if(type === "approvedHirerCompanies"){
      filterBody.filters.companyType = 1
      filterBody.filters.companyStatus = 4
    }
    if(type === "approvedProviderCompanies"){
      filterBody.filters.companyType = 2
      filterBody.filters.companyStatus = 4
    }
    if(type === "rejectedHirerCompanies"){
      filterBody.filters.companyType = 1
      filterBody.filters.companyStatus = 5
    }
    if(type === "rejectedProviderCompanies"){
      filterBody.filters.companyType = 2
      filterBody.filters.companyStatus = 5
    }
    if (type === 'blacklistedProviderCompanies') {
      filterBody.filters.companyType = 2
      filterBody.filters.companyStatus = 9
    }

    getAllCompanies(pageNumber, pageSize, searchValue, filterBody, sort).then((response) => { 
        if (response && response.status === 1) {
          setAllTotal( response && response.countWithFilter)
          if(type === "approvedHirerCompanies"){
            response.data.map((item: any) => {
              item.userDetails = [{
                "userEmail": item.userEmail,
                "firstName": item.firstName,
                "userPhoneNumber": item.userPhoneNumber,
                "dateOfReg": item.dateOfReg,
                "primary": true,
              }]
            })            
            setApprovedHirerComapnies(response.data)
            setApprovedHirerComapniesTotal(response.countWithFilter)
          }
          if(type === "approvedProviderCompanies"){
            response.data.map((item: any) => {
              item.userDetails = [{
                "userEmail": item.userEmail,
                "firstName": item.firstName,
                "userPhoneNumber": item.userPhoneNumber,
                "dateOfReg": item.dateOfReg,
                "primary": true,
              }]
            }) 
            setApprovedProviderComapnies(response.data)
            setApprovedProviderComapniesTotal(response.countWithFilter)
          }
          if(type === "rejectedHirerCompanies"){
            response.data.map((item: any) => {
              item.userDetails = [{
                "userEmail": item.userEmail,
                "firstName": item.firstName,
                "userPhoneNumber": item.userPhoneNumber,
                "dateOfReg": item.dateOfReg,
                "primary": true,
              }]
            }) 
            setRejectedHirerComapnies(response.data)
            setRejectedHirerComapniesTotal(response.countWithFilter)
          }
          if(type === "rejectedProviderCompanies"){
            response.data.map((item: any) => {
              item.userDetails = [{
                "userEmail": item.userEmail,
                "firstName": item.firstName,
                "userPhoneNumber": item.userPhoneNumber,
                "dateOfReg": item.dateOfReg,
                "primary": true,
              }]
            }) 
            setRejectedProviderComapnies(response.data)
            setRejectedProviderComapniesTotal(response.countWithFilter)
          }
          if(type === "blacklistedProviderCompanies"){
            response.data.map((item: any) => {
              item.userDetails = [{
                "userEmail": item.userEmail,
                "firstName": item.firstName,
                "userPhoneNumber": item.userPhoneNumber,
                "dateOfReg": item.dateOfReg,
                "primary": true,
              }]
            }) 
            setBlacklistedProviderCompanies(response.data)
            setBlacklistedCompaniesTotal(response.countWithFilter)
          }
        }
      })
  }

  const getPendingCompaniesData = (
    pageNumber: number,
    pageSize: number,
    searchValue: string,
    filters?: any,
    tab?: number,
    sort?: any
  ) => {

    let filterBody = {
      filters : {
        companyType: filters.companyType !== undefined ? filters.companyType : undefined ,
        range: filters.dateWithin ? { start : filters.dateWithin.fromDate , end : filters.dateWithin.toDate } : undefined,
        allocatedTo: filters.allocatedTo,
        companyStatus: filters.companyStatus !== undefined ? filters.companyStatus : undefined ,
        googleLocations: filters.googleLocations,
        skills: filters.skills,
        sourcedBy: filters.sourcedBy
      }
    }
 
    if(tab === 1){
      filterBody.filters.companyType = 1
    }
    if(tab === 2){
      filterBody.filters.companyType = 2
    }
    if(filterBody.filters.companyStatus === " "){
      delete filterBody.filters.companyStatus 
    }

    getPendingCompanies( pageNumber, pageSize, searchValue, filterBody).then((response) => { 
      if (response && response.status === 1) {
        switch (tab) {
          case 1:
            setHirerCompanyData(response.data)
            setHirerTotal(response.countWithFilter)
            break
          case 2:
            setProviderCompanyData(response.data)
            setProviderTotal(response.countWithFilter)
            break
        }
      }
    })
  }

  const getDraftCompaniesData  = (
    pageNumber: number,
    pageSize: number,
    searchValue: string,
    filters?: any,
    sort?: any
  ) => {

    let filterBody = {
      filters : {
        companyType: filters.companyType !== undefined ? filters.companyType : undefined ,
        range: filters.dateWithin ? { start : filters.dateWithin.fromDate , end : filters.dateWithin.toDate } : undefined,
        allocatedTo: filters.allocatedTo,
        companyStatus: filters.companyStatus !== undefined ? filters.companyStatus : 1 ,
        googleLocations: filters.googleLocations,
        sourcedBy: filters.sourcedBy,
        skills: filters.skills,
      }
    }
    
    if(filters && filterBody.filters.companyStatus === " "){
      delete filterBody.filters.companyStatus 
    }
    if(filters && filterBody.filters.companyType === " "){
      delete filterBody.filters.companyType 
    }

    getDraftCompanies(pageNumber, pageSize, searchValue, filterBody,sort).then((response) => { 
        if (response && response.status === 1) {
          setDraftCompanyData(response.data)
          setDraftTotal( response && response.countWithFilter)
        }
      })
  }

  const userLevelApproveReject = (data: any) => {
    
    userLevelApproveRejectCustomer(data).then((response) => {
      if (response && response.status === 1) {
        mixpanelData(`New TG - Company ${data.customerStatus === 4 ? 'Approved' : 'Rejected'}`, {
          'source': `Recruiter ${data.customerStatus === 4 ? 'Approved' : 'Rejected'} a company `,
          'Status': data.customerStatus === 4 ? 'Approved' : 'Rejected',
          'Company name': response.responseObj.Response[0].customer_metadata.companyName,
          'Company type': data.companyType === 1 ? 'Hirer' : 'Provider',
          'Verified by': localStorage.getItem('Email'), 
          'distinct_id': localStorage.getItem('Email'),
          'User email': response.responseObj.Response[0].customer_metadata.workEmail,
          'Company id': response.responseObj.Response[0].customer_id,
          "Created on": new Date(response.responseObj.Response[0].created_on).toDateString(),
          "Section": 'Reg-approval',
          'Source type': data.companyType === 1 ? 'Hirer' : 'Provider',
          'Source name': response.responseObj.Response[0].customer_metadata.companyName
        })
        getPendingCompaniesData(1, 25, "","", 1)
        getPendingCompaniesData(1, 25, "" , "",2)
        getDraftCompaniesData(1, 25, "", "")
        getAllCompaniesData(1, 25, "" , {"filters":{ "companyType": 1,"companyStatus": 4}},"", "approvedHirerCompanies")
        getAllCompaniesData(1, 25, "" , {"filters":{ "companyType": 2,"companyStatus": 4}},"", "approvedProviderCompanies")
        getAllCompaniesData(1, 25, "" , {"filters":{ "companyType": 1,"companyStatus": 5}},"", "rejectedHirerCompanies")
        getAllCompaniesData(1, 25, "" , {"filters":{ "companyType": 2,"companyStatus": 5}},"", "rejectedProviderCompanies")
      }
    })
  }

  const approveRejectCustomer = (data: any, section: string) => {
    approveOrRejectCustomer(data).then((response) => { 
      if (response && response.status === 1) {          
        mixpanelData(`New TG -  Company ${data.customerStatus === 4 ? 'Approved' : 'Rejected'}`, {
          'source': `Recruiter ${data.customerStatus === 4 ? 'Approved' : 'Rejected'} a company `,
          'Status': data.customerStatus === 4 ? 'Approved' : 'Rejected',
          'Company name': response.responseObj.UpdateResponse[0].customer_metadata.companyName,
          'distinct_id': localStorage.getItem('Email'),
          "Created on": new Date(response.responseObj.Response[0].created_on).toDateString(),
          "Section": section === 'allcompanies' ? 'All companies' : 'Draft',
          'Company type': data.companyType === 1 ? 'Hirer' : 'Provider',
          'Verified by': localStorage.getItem('Email'), 
          'User email': response.responseObj.UpdateResponse[0].customer_metadata.workEmail,
          'Company id': data.customerId,
          'Source type': data.companyType === 1 ? 'Hirer' : 'Provider',
          'Source name': section === 'allcompanies' ? response.responseObj.UpdateResponse[0].customer_metadata.companyName : response.responseObj.Response[0].customer_metadata.companyName
        })
          getPendingCompaniesData(1, 25, "",{"filters":{ "companyType": 1}}, 1)
          getPendingCompaniesData(1, 25, "" , {"filters":{ "companyType": 1}},2)
          getDraftCompaniesData(1, 25, "", "")
          getAllCompaniesData(1, 25, "" , {"filters":{ "companyType": 1,"companyStatus": 4}},"", "approvedHirerCompanies")
          getAllCompaniesData(1, 25, "" , {"filters":{ "companyType": 2,"companyStatus": 4}},"", "approvedProviderCompanies")
          getAllCompaniesData(1, 25, "" , {"filters":{ "companyType": 1,"companyStatus": 5}},"", "rejectedHirerCompanies")
          getAllCompaniesData(1, 25, "" , {"filters":{ "companyType": 2,"companyStatus": 5}},"", "rejectedProviderCompanies")
        }
    })  
  }
  
  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected);
  }
  
  const searchChange = (e: string) => {
   
    setsearchValue(e)
    let filters = filterValues !== null ? filter : {"filters":{ "companyType": " ","companyStatus": " "}}
    
    getDraftCompaniesData(1, 25, e, filters, "")
    getPendingCompaniesData(1, 25, e, filters, 1, "")
    getPendingCompaniesData(1, 25, e, filters, 2, "")
    getAllCompaniesData(1, 25, e , filters,"", "approvedHirerCompanies")
    getAllCompaniesData(1, 25, e , filters,"", "approvedProviderCompanies")
    getAllCompaniesData(1, 25, e, filters,"", "rejectedHirerCompanies")
    getAllCompaniesData(1, 25, e, filters, "", "rejectedProviderCompanies")
    getAllCompaniesData(1, 25, e ,filters,"", "blacklistedProviderCompanies")

  }
    
  const getPosition = (  pageSize: any, pageNumber: number, searchValue?: string, filter?: any) => {   
    let page = pageNumber !== 0 ? Math.floor(pageNumber / pageSize) + 1 : 1;   
    getPendingCompaniesData( page, pageSize, "", filterValues);
  }

  const handlePageChange = (pageSize: any, pageNumber: number) => {
    getAllCompaniesData(pageNumber, pageSize, "", {"filters":{ "companyType": 1,"companyStatus": 4}},"","approvedHirerCompanies")
    getAllCompaniesData(pageNumber, pageSize, "", {"filters":{ "companyType": 2,"companyStatus": 4}},"","approvedProviderCompanies")
    getAllCompaniesData(pageNumber, pageSize, "", {"filters":{ "companyType": 1,"companyStatus": 5}},"","rejectedHirerCompanies")
    getAllCompaniesData(pageNumber, pageSize, "", { "filters": { "companyType": 2, "companyStatus": 5 } }, "", "rejectedProviderCompanies")
    getAllCompaniesData(pageNumber, pageSize, "", { "filters": { "companyType": 2, "companyStatus": 9 } }, "", "blacklistedProviderCompanies")

  }

  const applyFilter = (data: any) => {
    
    let filter = {
      company: data.companyType !== undefined ? data.companyType.name : undefined ,
      dateWithin: data.dateWithin,
      allocatedTo: data.allocatedTo !== undefined ? data.allocatedTo.name : undefined,
      status: data.companyStatus !== undefined ? [data.companyStatus.name] : undefined ,
      googleLocations: data.googleLocations,
      skills: data.skills,
      sourcedBy: data.sourcedBy

    }    
    setFilterValues(filter) 
    
    let value = {
        companyType: data.companyType !== undefined ? data.companyType.id : undefined ,
        range: data.dateWithin ? { start : data.dateWithin.fromDate , end : data.dateWithin.toDate } : undefined,
        allocatedTo: data.allocatedTo !== undefined ? data.allocatedTo.id : undefined,
        companyStatus: data.companyStatus !== undefined ? data.companyStatus.id : undefined ,
        googleLocations: data.googleLocations,
        skills: data.skills,
        sourcedBy: data.sourcedBy
    }
    setFilter(value)   
    let searchChange = searchValue !== null ? searchValue : ""  
    
    getDraftCompaniesData(1, 25, searchChange, value)
    getPendingCompaniesData(1, 25, searchChange, value, 1, "")
    getPendingCompaniesData(1, 25, searchChange, value, 2, "")
    getAllCompaniesData(1, 25, searchChange, value,"","approvedHirerCompanies")
    getAllCompaniesData(1, 25, searchChange, value,"","approvedProviderCompanies")
    getAllCompaniesData(1, 25, searchChange, value,"","rejectedHirerCompanies")
    getAllCompaniesData(1, 25, searchChange, value, "", "rejectedProviderCompanies")
    getAllCompaniesData(1, 25, searchChange, value,"","blacklistedProviderCompanies")

  }

  const applySort = (data: any) => {
      
    getAllCompaniesData(1, 25, "" , '',sort)
    getPendingCompaniesData(1, 25, "", '', 1,sort)
    getPendingCompaniesData(1, 25,"" , '', 2,sort)
    getDraftCompaniesData(1, 25, "",'',sort)
    getAllCompaniesData(1, 25, "" , {"filters":{ "companyType": 1,"companyStatus": 4}},sort, "approvedHirerCompanies")
    getAllCompaniesData(1, 25, "" , {"filters":{ "companyType": 2,"companyStatus": 4}},sort, "approvedProviderCompanies")
    getAllCompaniesData(1, 25, "" , {"filters":{ "companyType": 1,"companyStatus": 5}},sort, "rejectedHirerCompanies")
    getAllCompaniesData(1, 25, "", { "filters": { "companyType": 2, "companyStatus": 5 } }, sort, "rejectedProviderCompanies")
    getAllCompaniesData(1, 25, "", { "filters": { "companyType": 2, "companyStatus": 9 } }, sort, "blacklistedProviderCompanies")

  }

  const closeTag = (data: any) => {
      
      if(data.company === 'Hirer'){
        data.company = {name: 'Hirer', id: 1}
      }
      if(data.company === 'Provider'){
        data.company = {name: 'Provider', id: 2}
      }
      if(data.company === 'Both'){
        data.company = {name: 'Both', id: 3}
      }
      
      let filter = {
        company: data.company !== undefined ? data.company.name : undefined ,
        dateWithin: data.dateWithin,
        allocatedTo: data.allocatedTo !== undefined ? data.allocatedTo.name : undefined,
        status: data.status !== undefined ? [data.status] : undefined ,
        googleLocations: data.googleLocations,
        sourcedBy: data.sourcedBy,
        skills: data.skills
      } 
      setFilterValues(filter) 
      
      let value = {
          companyType: data.company !== undefined  && data.company !== undefined ? data.company.id : undefined ,
          range: data.dateWithin ? { start : data.dateWithin.fromDate , end : data.dateWithin.toDate } : undefined,
          allocatedTo: data.allocatedTo !== undefined ?  data.allocatedTo.id : undefined,
          companyStatus: data.companyStatus !== undefined ? data.companyStatus.id : undefined ,
          googleLocations: data.googleLocations,
          sourcedBy: data.sourcedBy,
          skills: data.skills
      }  
      setFilter(value)
      let searchChange = searchValue !== null ? searchValue : ""  

      getDraftCompaniesData(1, 25, searchChange, value)
      getPendingCompaniesData(1, 25, searchChange, value, 1, "")
      getPendingCompaniesData(1, 25, searchChange, value, 2, "")
      getAllCompaniesData(1, 25, searchChange,  value,sort, "approvedHirerCompanies")
      getAllCompaniesData(1, 25, searchChange, value,sort, "approvedProviderCompanies")
      getAllCompaniesData(1, 25, searchChange, value,sort, "rejectedHirerCompanies")
      getAllCompaniesData(1, 25, searchChange, value, sort, "rejectedProviderCompanies")
      getAllCompaniesData(1, 25,  searchChange, value,sort, "blacklistedProviderCompanies")

  }

  const submitSourcedBy = (data: any) => {
    updateSourcedBy(data).then((response: any) => {
      
    })
  }

  const SubmitCustomerAllocation = (data: any) => {
    customerAllocation(data).then((response: any) => {
      if(response && response.status === 1){
        getAllCompaniesData(1, 25, "" , { "companyType": 1,"companyStatus": 4},"", "approvedHirerCompanies")
        getAllCompaniesData(1, 25, "" , { "companyType": 2,"companyStatus": 4},"", "approvedProviderCompanies")
        getAllCompaniesData(1, 25, "" , { "companyType": 1,"companyStatus": 5},"", "rejectedHirerCompanies")
        getAllCompaniesData(1, 25, "", { "companyType": 2, "companyStatus": 5 }, "", "rejectedProviderCompanies")
        getAllCompaniesData(1, 25, "" , { "companyType": 2,"companyStatus": 9},"", "blacklistedProviderCompanies")

      }
    })
  }
  
  const displayNotification = (message: string) => {
    setMessage(message)
    setNotification(true)
    setTimeout(() => {
      setNotification(false)
      if (message === 'Company blacklisted successfully') {
        getAllCompaniesData(1, 25, "", { "companyType": 2, "companyStatus": 4 }, "", "approvedProviderCompanies")
        getAllCompaniesData(1, 25, "" , { "companyType": 2,"companyStatus": 9},"", "blacklistedProviderCompanies")
      }
    }, 3000)
  }

  const blackListCustomer = (data: any) => {
    blackListProvider(data).then((response) => {  
        if (response && response.status === 1) {
          setIcon(true)
          setType('success')
          displayNotification('Company blacklisted successfully')
        }
        else if (response && response.errorResponse && response.errorResponse.status === 2) {
          setIcon(false)
          setType('error')
          displayNotification('Sorry, unable to perform action. Active contracts exist for this company')
        }
      })
  }

  return (
    <section className="dashboardWrapper">
      <SideMenu menu={menu} />
      <div className="dashboardContent">
        <DashboardHeader
          title={BreadcrumsValues}
          applyCompanyFilter={applyFilter}
          searchChange={searchChange}
          closeTag={closeTag}
          navigateTo="../createCompany"
          filterValues={filterValues}
          allocatedTo={allocatedTo}
          type='company'
          skillsList={skillList}
        />
        {notification && <NotificationAlert onClose={() => setNotification(false)} closable={true} icon={icon} type={type}>
          {message}
        </NotificationAlert>}
      <section className={Styles.dashboardWrapper}>
      <TabStrip selected={selected} onSelect={handleSelect}>
          <Tab title={"Registration Approval"} >
            <CompanyTab setSort={setSort} applySort={applySort} hirerCompanies={hirerCompanyData} providerCompanies={providerCompanyData} pageSize={getPosition} approveOrRejectCustomer={userLevelApproveReject} hirerTotal={hirerTotal} providerTotal={providerTotal} />
          </Tab>
          <Tab title={"Approved companies"} >
              <AllCompaniesTab setSort={setSort} applySort={applySort} approveOrRejectCustomer={(data: any) => approveRejectCustomer(data, 'allcompanies')} total={allTotal} handlePageChange={handlePageChange} submitSourcedBy={submitSourcedBy} hirerComapnies={approvedHirerComapnies} providerComapnies={approvedProviderComapnies} hirerTotal={approvedHirerComapniesTotal} providerTotal={approvedProviderComapniesTotal} allocatedToList={allocatedTo} SubmitCustomerAllocation={SubmitCustomerAllocation} type={'approved'} blackListCustomer={blackListCustomer}/>
          </Tab>
          <Tab title={"Rejected companies"} >
            <AllCompaniesTab setSort={setSort} applySort={applySort} approveOrRejectCustomer={(data: any) => approveRejectCustomer(data, 'allcompanies')} total={allTotal} handlePageChange={handlePageChange} submitSourcedBy={submitSourcedBy} hirerComapnies={rejectedHirerComapnies} providerComapnies={rejectedProviderComapnies} hirerTotal={rejectedHirerComapniesTotal} providerTotal={rejectedProviderComapniesTotal} allocatedToList={allocatedTo} SubmitCustomerAllocation={SubmitCustomerAllocation}/>
            </Tab>
            <Tab title={"Blacklisted Provider"} >
              <AllCompaniesTab setSort={setSort} applySort={applySort} approveOrRejectCustomer={(data: any) => approveRejectCustomer(data, 'allcompanies')} total={allTotal} handlePageChange={handlePageChange} submitSourcedBy={submitSourcedBy} hirerComapnies={rejectedHirerComapnies} providerComapnies={blacklistedProviderCompanies} hirerTotal={rejectedHirerComapniesTotal} providerTotal={blackListedCompaniesTotal} allocatedToList={allocatedTo} SubmitCustomerAllocation={SubmitCustomerAllocation} type={'blacklisted'} />
          </Tab>
          <Tab title={"Draft Companies"}>
            <DraftCompanies setSort={setSort} applySort={applySort} data={draftCompanyData} pageSize={getDraftCompaniesData} total={draftTotal} approveOrRejectCustomer={(data: any) => approveRejectCustomer(data, 'draft')}/>
          </Tab>
      </TabStrip>
      </section>
      </div>
    </section>
  )
}

export default Company